// Platform detection for shortcut hint labels.
//
// Mac users expect ⌘ (Cmd) in keyboard hints; everyone else expects Ctrl.
// This module does cheap UA sniffing ONCE at load time and exports prebuilt
// labels for the shortcuts we show in the UI. Keyboard HANDLERS still accept
// both ctrlKey and metaKey — this is strictly about what we render.
//
// We use navigator.platform as the primary signal (most reliable for desktop
// Safari/Chrome) and fall back to the UA string. SSR-safe: falls back to the
// non-Mac path when window is absent.

function detectMac() {
  if (typeof navigator === 'undefined') return false;
  const p = (navigator.platform || '').toLowerCase();
  if (p.includes('mac')) return true;
  // Modern Chrome on Apple Silicon reports MacIntel, but older browsers or
  // iPads-in-desktop-mode sometimes only expose userAgent hints.
  const ua = (navigator.userAgent || '').toLowerCase();
  return ua.includes('macintosh') || ua.includes('mac os x');
}

export const IS_MAC = detectMac();

// Modifier glyph used inline: "⌘N" vs "Ctrl+N".
export const MOD_KEY = IS_MAC ? '⌘' : 'Ctrl';

// "Plus" separator — on Mac the Cmd glyph sits directly against the key
// letter with no "+"; on other platforms we join with "+".
const SEP = IS_MAC ? '' : '+';

// Prebuilt labels for the shortcuts we render as Hint badges / placeholder
// copy. Capitalisation matches the convention on each platform (Mac uses
// uppercase letters with the glyph; Windows/Linux convention is "Ctrl+N"
// with an uppercase letter).
// Walter 2026-05-06 round 8: `newList` shows plain "n" everywhere
// because Ctrl+N is grabbed by Windows browsers (new window). On
// Mac we still wire ⌘N in the handler, but the user-facing hint is
// the simpler shortcut so the empty-board copy reads consistently.
export const SHORTCUT = {
  newList:    'n',
  // Walter 2026-06-16: the header "search" button is the CROSS-BOARD search,
  // which moved to Shift+Ctrl/Cmd+F (plain Ctrl/Cmd+F is now the in-list
  // find bar). The hint must match.
  search:     IS_MAC ? `⇧${MOD_KEY}F` : `Shift+${MOD_KEY}${SEP}F`,
  find:       `${MOD_KEY}${SEP}F`,
  expand:     `${MOD_KEY}${SEP}E`,
};
